import { render, staticRenderFns } from "./NewAccreditation.vue?vue&type=template&id=736d8f95&scoped=true"
import script from "./NewAccreditation.vue?vue&type=script&lang=js"
export * from "./NewAccreditation.vue?vue&type=script&lang=js"
import style0 from "./NewAccreditation.vue?vue&type=style&index=0&id=736d8f95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736d8f95",
  null
  
)

export default component.exports